var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-block',{attrs:{"column":_vm.tableData.column,"pagination":true,"pageTotal":20,"pageSize":5,"currentPage":1,"data":_vm.tableData.data}})}
var staticRenderFns = []

export { render, staticRenderFns }